import AvatarPic1 from "../../assets/img/avatar/avatar-1.png";
import AvatarPic2 from "../../assets/img/avatar/avatar-2.png";
import AvatarPic3 from "../../assets/img/avatar/avatar-3.png";
import AvatarPic4 from "../../assets/img/avatar/avatar-4.png";
import AvatarPic5 from "../../assets/img/avatar/avatar-5.png";
import AvatarPic6 from "../../assets/img/avatar/avatar-6.png";

import "./InterviewsComponent.css";
import candidateGrid from "../../assets/candidateGrid.json";
const candidates: CandidateItem[] = candidateGrid as CandidateItem[];

const imageMap: Record<string, string> = {
  AvatarPic1,
  AvatarPic2,
  AvatarPic3,
  AvatarPic4,
  AvatarPic5,
  AvatarPic6
};

type CandidateItem = {
  name: string;
  location: string;
  skills: string[];
  image: string;
  alt: string;
};


const InterviewsComponent = () => {
    return (
        <section className="md section6">
            <div className="container-body">
                <div className="text-center">
                    <h2 className="section-title">Candidates Who Excelled</h2>
                    <p className="section-info">Some of the top candidates we’ve interviewed who have gone on to thrive in leading roles across the industry.</p>
                </div>
                <div className="candidate-grid">
                    {candidates.map((candidate, idx) => (
                        <div className="candidate-card" key={idx}>
                            <div className="candidate-photo">
                                <img src={imageMap[candidate.image]} alt={candidate.alt} />
                            </div>
                            <div className="candidate-info">
                                <h3>{candidate.name}</h3>
                                <p><i className="fas fa-map-marker-alt"></i>{candidate.location}</p>
                                <p className="skills">
                                    <i className="fas fa-code"></i>
                                    {candidate.skills.join(", ")}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};
export default InterviewsComponent;